import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
import { QuoteIcon, ShieldIcon, PiggyBankIcon, HeartPulseIcon } from 'lucide-react';
const testimonials = [{
  name: 'Juan R.',
  age: '32 años',
  role: 'Gerente de Ventas',
  focus: 'Protección Familiar',
  icon: <ShieldIcon className="w-5 h-5 text-navy" data-id="element-127" />,
  quote: 'Lo que más me pesaba era no saber qué pasaría con la universidad de mis hijos si yo llegaba a faltar. Con la asesoría de Seguros Monterrey New York Life, entendí que con solo $5,000 MXN al mes podía garantizarles un fondo de $5.5 Millones de pesos. Hoy duermo tranquilo: mi familia tiene un contrato blindado con la aseguradora más sólida de México. Pase lo que pase, su futuro no está en riesgo.',
  highlight: '$5.5 Millones',
  highlightLabel: 'Fondo garantizado'
}, {
  name: 'Mauricio G.',
  age: '45 años',
  role: 'Director de Operaciones',
  focus: 'Retiro y Beneficio Fiscal',
  icon: <PiggyBankIcon className="w-5 h-5 text-navy" data-id="element-128" />,
  quote: 'Me aterraba llegar a los 65 y depender solo de una AFORE insuficiente. En Seguros Monterrey me diseñaron un plan dotal donde sé exactamente cuánto voy a recibir. Gracias a este esquema, no solo estoy ahorrando para mi retiro, sino que el SAT me regresa impuestos cada año por la deducibilidad. Es la paz de saber que mi dinero crece con el respaldo de 110 años de historia.',
  highlight: '110 años',
  highlightLabel: 'De respaldo'
}, {
  name: 'Elena M.',
  age: '38 años',
  role: 'Dueña de Negocio',
  focus: 'Invalidez y Paz Mental',
  icon: <HeartPulseIcon className="w-5 h-5 text-navy" data-id="element-129" />,
  quote: 'Como independiente, mi mayor miedo era una enfermedad que me impidiera producir. Mi plan de Seguros Monterrey New York Life tiene una cláusula donde el plan se auto-paga si llego a tener una invalidez, y mi ahorro de más de $6 millones sigue intacto para mi vejez. Me quitaron la incertidumbre y me dieron el respaldo de la compañía líder en vida. Es la mejor decisión que he tomado.',
  highlight: '$6M+',
  highlightLabel: 'Ahorro protegido'
}];
export function Testimonials() {
  return <Section bg="navy-light" data-id="element-130">
      <div className="text-center mb-8 md:mb-16" data-id="element-131">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-6" data-id="element-132">
          Historias de <span className="text-gold" data-id="element-133">Blindaje Real</span>
        </h2>
        <p className="text-gray-light text-sm md:text-lg max-w-2xl mx-auto" data-id="element-134">
          Personas reales que tomaron la decisión de proteger su patrimonio y el
          futuro de sus familias.
        </p>
        <div className="w-16 md:w-24 h-1 bg-gold mx-auto mt-4 md:mt-6" data-id="element-135"></div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-136">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.15,
        duration: 0.5
      }} className="bg-navy rounded-xl md:rounded-2xl border border-white/5 overflow-hidden flex flex-col" data-id="element-137">
            {/* Header */}
            <div className="p-4 md:p-6 border-b border-white/5" data-id="element-138">
              <div className="flex items-center justify-between mb-3" data-id="element-139">
                <div className="flex items-center gap-3" data-id="element-140">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gold/20 border border-gold/30 flex items-center justify-center text-gold font-bold text-sm md:text-base" data-id="element-141">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-142">
                    <p className="font-bold text-white text-sm md:text-base" data-id="element-143">
                      {t.name}
                    </p>
                    <p className="text-gray-dark text-xs md:text-sm" data-id="element-144">
                      {t.age} · {t.role}
                    </p>
                  </div>
                </div>
                <div className="w-8 h-8 bg-gold rounded-lg flex items-center justify-center shrink-0" data-id="element-145">
                  {t.icon}
                </div>
              </div>
              <span className="inline-block text-xs font-semibold uppercase tracking-wider text-gold bg-gold/10 px-2.5 py-1 rounded-full" data-id="element-146">
                {t.focus}
              </span>
            </div>

            {/* Quote */}
            <div className="p-4 md:p-6 flex-1" data-id="element-147">
              <QuoteIcon className="w-6 h-6 text-gold/30 mb-2" data-id="element-148" />
              <p className="text-gray-light text-sm md:text-base leading-relaxed" data-id="element-149">
                {t.quote}
              </p>
            </div>

            {/* Highlight stat */}
            <div className="px-4 md:px-6 pb-4 md:pb-6" data-id="element-150">
              <div className="bg-navy-light rounded-lg p-3 md:p-4 text-center border border-gold/10" data-id="element-151">
                <p className="text-gold font-playfair font-bold text-xl md:text-2xl" data-id="element-152">
                  {t.highlight}
                </p>
                <p className="text-gray-dark text-xs md:text-sm" data-id="element-153">
                  {t.highlightLabel}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}